import { render, staticRenderFns } from "./YourResponsibilitiesTab.vue?vue&type=template&id=055f9fce"
import script from "./YourResponsibilitiesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./YourResponsibilitiesTab.vue?vue&type=script&setup=true&lang=js"
import style0 from "./YourResponsibilitiesTab.vue?vue&type=style&index=0&id=055f9fce&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports